import { useEffect, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { Link, useNavigate, useParams } from "react-router-dom";

import Announcement from '../components/Announcement';
import Footer from '../components/Footer';
import Mitra from '../components/Mitra';
import Navbar from '../components/Navbar';

import Slider from '../components/Slider';

import { red } from '@mui/material/colors';

import styledComponents from "styled-components";

import axios from  "axios";

import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Divider,
  Grid,
  Typography,
  TextField,
  Button,
  IconButton
} from "@mui/material";

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const Blog = (Props) => {
  const navigate = useNavigate();
  const params = useParams();
  const [blogData, setBlogData] = useState(null);
  const [token, setToken] = useState(
    JSON.parse(localStorage.getItem('token')) !== null ?
      JSON.parse(localStorage.getItem('token')).token :
      null
  );
  const hari = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
  const bulan = ['Januari', 'Februari', 'Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'];

  useEffect(() => {
    if (verifyToken(token)) {
      navigate('/dashboard');
    }
    const getBlogs = async () => {
      try {
        const getBlogData = await axios.get(`${process.env.REACT_APP_API_URL}/api/blog/${params.idblog}`);
        setBlogData(getBlogData.data.result);
      } catch (err) {
        console.log(err);
      }
    };
    getBlogs();
  }, []);

  return (
    <div>
      <Navbar Cart={Props.Cart} />
      <Slider />
      <Container>
        <Grid container>
          <Grid item xs={12} sx={{ paddingY: '10px' }}>
            <IconButton onClick={() => navigate('/')} size="large">
              <ChevronLeftIcon fontSize="large" />
            </IconButton>
          </Grid>
          <Grid item xs={12} sx={{ paddingY: '20px' }}>
            <Card sx={{ display: { xs: 'none', lg: 'flex' } }}>
              {/* <CardMedia
                component="img"
                sx={{ width: 640 }}
                image="https://media.karousell.com/media/photos/products/2023/5/13/legging_loss_rok_span_by_wnj_1683972039_1c93bd19_progressive.jpg"
              /> */}
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                      {blogData?.author.substring(0,2).toUpperCase()}
                    </Avatar>
                  }
                  title={
                    <Typography variant="h6">
                      {blogData?.judul}
                    </Typography>
                  }
                  subheader={`${hari[new Date(blogData?.created_at).getDay()]}, ${new Date(blogData?.created_at).getDate()} ${bulan[new Date(blogData?.created_at).getMonth()]} ${new Date(blogData?.created_at).getFullYear()}`}
                />
                <CardContent sx={{ flex: '1 0 auto', paddingX: '30px' }}>
                  <Typography variant="body1" color="text.secondary" component="div">
                    <div> 
                      <img
                        src={`${process.env.REACT_APP_ADMIN_URL}${blogData?.gambar}`}
                        alt="Longtail boat in Thailand"
                        style={{ float: 'left', paddingRight: '25px', height: '350px' }}
                      />
                    </div>
                    {blogData && (
                      <div
                        dangerouslySetInnerHTML={{__html: blogData.isi}}
                      />
                    )}
                  </Typography>
                </CardContent>
                <CardActions>
                  <IconButton aria-label="add to favorites">
                    <FavoriteIcon />
                  </IconButton>
                  <IconButton aria-label="share">
                    <ShareIcon />
                  </IconButton>
                </CardActions>
              </Box>
            </Card>
            {/* MOBILE BELOW */}
            <Card sx={{ display: { xs: 'block', lg: 'none' } }}>
              <CardHeader
                avatar={
                  <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                    {blogData?.author.substring(0,2).toUpperCase()}
                  </Avatar>
                }
                title={
                  <Typography variant="h6">
                    {blogData?.judul}
                  </Typography>
                }
                subheader={`${hari[new Date(blogData?.created_at).getDay()]}, ${new Date(blogData?.created_at).getDate()} ${bulan[new Date(blogData?.created_at).getMonth()]} ${new Date(blogData?.created_at).getFullYear()}`}
              />
              <CardMedia
                component="img"
                image={`${process.env.REACT_APP_ADMIN_URL}${blogData?.gambar}`}
              />
              <CardContent>
                <Typography variant="body1" color="text.secondary" component="div">
                  {blogData && (
                    <div
                      dangerouslySetInnerHTML={{__html: blogData.isi}}
                    />
                  )}
                </Typography>
              </CardContent>
              <CardActions>
                <IconButton aria-label="add to favorites">
                  <FavoriteIcon />
                </IconButton>
                <IconButton aria-label="share">
                  <ShareIcon />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  )
};

export default Blog;
